import { SlackSenderLayout } from "../SlackSenderLayout";
import { NSARouterMakerResult, NSAVerificationPage } from "namirasoft-account-react";
import { SlackSenderRouterProps } from "../SlackSenderRouterProps";
import { useParams } from "react-router-dom";
import { NSBoxString } from "namirasoft-site-react";
import { useRef } from "react";
import { SlackSenderRoutes } from "../SlackSenderRoutes";

export interface VerifyBotPageProps extends NSARouterMakerResult, SlackSenderRouterProps { }

function VerifyBotPage(props: VerifyBotPageProps)
{
	let NSBoxString_Channel = useRef<NSBoxString>(null);

	let { provider_id } = useParams();

	return (
		<SlackSenderLayout {...props}
			action={{
				title: "Verify Bot",
				description: "Enter the verification code sent to your channel to confirm your request and activate the service.",
				menus: {}
			}}
		>
			<NSAVerificationPage
				{...props}
				contact_type={"Bot"}
				contact_value_name={"Message"}
				getContactValue={(checkErrors: boolean) =>
				{
					return NSBoxString_Channel.current?.getValue(checkErrors) ?? "";
				}}
				onRequest={async () =>
				{
					let channel = NSBoxString_Channel.current?.getValue(false) ?? "";
					if (provider_id)
						await props.servers.slack_sender.provider.Request(provider_id, { channel });
				}}
				onVerify={async code =>
				{
					if (provider_id)
						await props.servers.slack_sender.provider.Verify(provider_id, { code });
				}}
				onFinished={() =>
				{
					if (provider_id)
						props.url.redirect(SlackSenderRoutes.ProviderView(provider_id), {});
				}}
			>
				<NSBoxString
					ref={NSBoxString_Channel}
					title="Channel"
					required={false}
					style={{ width: "100%" }}
				/>
			</NSAVerificationPage>
		</SlackSenderLayout>
	);
}

export default VerifyBotPage;